if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-image-id="${this.openedBy.getAttribute('data-counter')}"]`);

        const slider = this.querySelector(".product-media-modal__content");
        const currentActiveImg = this.querySelector(".lightbox-img-wrapper.focused");

        currentActiveImg?.classList?.remove("focused");
        activeMedia.classList.add("focused");

        const padding = window.innerWidth < 768 ? 10 : 100;
        slider.style.transform = `translateX(calc((-98dvw + ${padding * 2}px) * ${parseInt(this.openedBy.getAttribute('data-counter'))}))`;

        const prevBtn = this.querySelector("[id*='ModalPrev']");
        const nextBtn = this.querySelector("[id*='ModalNext']");

        if (parseInt(this.openedBy.getAttribute('data-counter')) == 0)
        {
          prevBtn.classList.add("disabled");
          nextBtn.classList.remove("disabled");
        }
        else if (parseInt(this.openedBy.getAttribute('data-counter')) == this.querySelectorAll(".lightbox-img-wrapper").length - 1)
        {
          nextBtn.classList.add("disabled");
          prevBtn.classList.remove("disabled");
        }
        else {
          prevBtn.classList.remove("disabled");
          nextBtn.classList.remove("disabled");
        }
        /*const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();*/
      }
    }
  );
}
